import {useNavigate, useParams} from "react-router-dom";
import {fetchWithToken, postWithToken} from "../../api/apiBase";
import {blank_bid} from "../bid/bidding_model";
import {Button} from "../ui/button";
import {useAuthInfo} from "@propelauth/react";
import {useToast} from "../../hooks/use-toast";
import {Simulate} from "react-dom/test-utils";
import error = Simulate.error;


interface CreateBidButtonProps  {
    text?: string | null;
    scope_id_arg?: string | null;
}

export default function CreateBidButton({text, scope_id_arg}: CreateBidButtonProps) {
    const {accessToken} = useAuthInfo();
    const navigate = useNavigate();
    const {toast} = useToast();
    const {project_id, scope_id} = useParams<{ project_id: string, scope_id?: string }>();

    const checkForScopes = async () => {
        const target_scope = (scope_id? scope_id : (scope_id_arg? scope_id_arg: null));
        if (target_scope === null){
            return fetchWithToken(`/projects/${project_id}/scopes`, accessToken as string)
                .then((res) => {
                        console.log(res);
                        if(res && res.length > 0){
                            return `/projects/${project_id}/scope/${res[0].id}/bidding/create`
                        } else {
                            return `/projects/${project_id}/bidding/create`;
                        }
                    }
                ).catch((error) => {
                    return `/projects/${project_id}/bidding/create`;
            })
        }
        return `/projects/${project_id}/scope/${target_scope}/bidding/create`

    };

    const onCreateBid = async () => {
        const url = await checkForScopes();
        console.log(url);
        postWithToken(url as string, JSON.stringify(blank_bid()), accessToken as string)
            .then((new_data) => {
                // console.log(new_data)
                navigate(`/project/${project_id}/bid/${new_data.id}`);
            })
            .catch((error) => {
                console.error("Error creating bid:", error);
                toast({
                    title: "Error",
                    description: "Failed to create bid: " + JSON.stringify(error),
                    variant: "destructive",
                })
            });
    };

    return <Button variant="outline"
                   className="bg-green-200"
                   onClick={(e) => onCreateBid()}>
        {text? text : "New Bid"}
    </Button>
}